import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { AddTransactionType } from '../Pages/Frontend/Components/Transactions/AddTransaction/AddTransaction'
import { AddTransactionTransferFormType } from '../Pages/Frontend/Components/Transactions/InternalTransferTransaction/InternalTransferTransaction'

AxiosInterceptor()

const transactionService = {
  async index(
    pageNumber: number,
    sortOrder: string,
    status: string,
    transactionFlowType: string | undefined,
    includePOSTransactions: boolean | undefined,
  ) {
    let url = `/financialtransactions?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}`

    if (transactionFlowType) {
      url += `&transactionFlowType=${transactionFlowType}`
    }

    if (includePOSTransactions !== undefined) {
      url += `&includePOSTransactions=${includePOSTransactions}`
    }

    return axios.get(url)
  },

  async single(pageNumber: number, id: string | undefined) {
    return axios.get(`/financialtransactions?pageNumber=${pageNumber}&id=${id}`)
  },

  async create(data: AddTransactionType) {
    return axios.post('/financialtransactions', data)
  },

  searchTransaction: async (
    endpoint: string,
    pageNumber: number,
    sortOrder: string,
    transactionFlowType: string | undefined,
    includePOSTransactions: boolean | undefined,
  ) => {
    let url = `/financialtransactions?${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}`

    if (transactionFlowType) {
      url += `&transactionFlowType=${encodeURIComponent(transactionFlowType)}`
    }

    if (includePOSTransactions !== undefined) {
      url += `&includePOSTransactions=${includePOSTransactions}`
    }

    return axios.get(url)
  },

  async exportTransaction(
    // pageNumber: number,
    sortOrder: string,
    transactionFlowType?: string,
    customerMsisdn?: string,
  ) {
    let url = `/financialtransactions/export?sortOrder=${sortOrder}`
    // pageNumber=${pageNumber}&`

    if (transactionFlowType) {
      url += `&transactionFlowType=${transactionFlowType}`
    }

    if (customerMsisdn) {
      url += `&customerMsisdn=${customerMsisdn}`
    }

    return axios.get(url)
  },

  async debitTransfer(data: AddTransactionTransferFormType) {
    return axios.post('/orderDebtTransfer', data)
  },
}
export default transactionService
